import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { handleError } from "../../../../../utils/ErrorHandler";

const initialState = {
	list: [],
	addingTask:false,
	task: null,
	error: "",
	total: null,
	loading: false,
	isFetchingBookings: false,
};

// ADD_task
export const addSingleTask = createAsyncThunk(
	"task/addSingleTask",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `crm-task/`,
				data: {
					...values,
				},
			});
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding task try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// Get Available slots date wise
export const getAvailableSlots = createAsyncThunk(
	"task/getAvailableSlots",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `slots/filter`,
				data: {
					...values,
				},
			});
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("No slots available please try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_task
export const deleteTask = createAsyncThunk("task/deleteTask ", async (id) => {
	try {
		const resp = await axios({
			method: "delete",
			url: `slots/${id}`,
		});
		toast.success("Slot deleted successfully!")
		return {
			message: "success",
		};
	} catch (error) {
		toast.error("Error in deleting task try again");
		console.log(error.message);
	}
});

// DELETE Many_contact
export const deleteManyTask = createAsyncThunk(
	"contact/deleteManyTask ",
	async (data) => {
		try {
			const resp = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `task?query=deletemany`,
				data: data,
			});

			toast.success("Task Deleted");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Task, try again");
			console.log(error.message);
		}
	}
);

// task_DETAILS
export const loadSingleTask = createAsyncThunk(
	"task/loadSingleTask",
	async (id) => {
		try {
			const data = await axios.get(`crm-task/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// taskS
export const loadAllTask = createAsyncThunk("task/loadAllTask", async () => {
	try {
		const { data } = await axios.get(`crm-task?query=all`);
		return data;
	} catch (error) {
		console.log(error.message);
	}
});

// loadAllTask paginated
export const loadAllTaskPaginated = createAsyncThunk(
    "task/loadAllTaskPaginated",
    async ({ page, count, status }) => {
        try {
            const response = await axios.get(
                `slots/available?status=${status}&page=${page}&count=${count}`
            );
            return response.data; 
        } catch (error) {
            console.error("Error fetching tasks:", error.message);
            throw error; 
        }
    }
);
// loadAllTask paginated
export const loadSlotsByFranchiseId = createAsyncThunk(
    "task/loadSlotsByFranchiseId",
    async (id) => {
        try {
            const response = await axios.get(
                `slots/?franchiseId=${id}&query=all`
            );
            return response.data; 
        } catch (error) {
            console.error("Error fetching tasks:", error.message);
            throw error; 
        }
    }
);

export const updateTask = createAsyncThunk(
	"task/updateTask",
	async ({ id, values }) => {
		try {
			console.log("this si idd :: ",id, values)
			const { data } = await axios({
				method: "put",

				url: `slots/${id}`,
				data: {
					...values,
				},
			});
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating task try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// Create Booking
export const createBookingTask = createAsyncThunk(
	"task/slot-booking",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `slot-booking`,
				data: {
					...values,
				},
			});
			toast.success("Booking created successfully!")
			return {
				data,
				message: "success",
			};
		} catch (error) {
			handleError(error);
		}
	}
);

const crmTaskSlice = createSlice({
	name: "task",
	initialState,
	reducers: {
		clearTask: (state) => {
			state.task = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAlltask ======

		builder.addCase(createBookingTask.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(createBookingTask.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(createBookingTask.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		// 1) ====== builders for loadAlltask ======

		builder.addCase(loadAllTask.pending, (state) => {
			state.isFetchingBookings = true;
		});

		builder.addCase(loadAllTask.fulfilled, (state, action) => {
			state.isFetchingBookings = false;
			state.list = action.payload;
		});

		builder.addCase(loadAllTask.rejected, (state, action) => {
			state.isFetchingBookings = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for loadAllTaskPaginated ======

		// builder.addCase(loadAllTaskPaginated.pending, (state) => {
		// 	state.loading = true;
		// });

		// builder.addCase(loadAllTaskPaginated.fulfilled, (state, action) => {
		// 	state.loading = false;
		// 	state.list = action.payload?.getAllTask;
		// 	state.total = action.payload?.aggregation?._count?.id;
		// });

		// builder.addCase(loadAllTaskPaginated.rejected, (state, action) => {
		// 	state.loading = false;
		// 	state.error = action.payload.message;
		// });

		builder.addCase(loadAllTaskPaginated.pending, (state) => {
			state.loading = true;
		});
		  
		builder.addCase(loadAllTaskPaginated.fulfilled, (state, action) => {
		state.loading = false;
		state.list = action.payload || [];
		});
		
		builder.addCase(loadAllTaskPaginated.rejected, (state, action) => {
		state.loading = false;
		state.error = action.error.message;
		});

		// 2) ====== builders for addSingleTask  ======

		builder.addCase(addSingleTask.pending, (state) => {
			state.addingTask = true;
		});

		builder.addCase(addSingleTask.fulfilled, (state, action) => {
			state.addingTask = false;
		});

		builder.addCase(addSingleTask.rejected, (state, action) => {
			state.addingTask = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for loadSingletask ======

		builder.addCase(loadSingleTask.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleTask.fulfilled, (state, action) => {
			state.loading = false;
			state.task = action.payload.data;
		});

		builder.addCase(loadSingleTask.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for task ======

		builder.addCase(updateTask.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateTask.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateTask.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteTask  ======

		builder.addCase(deleteTask.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteTask.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteTask.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		// 4) ====== builders for deleteTask  ======

		builder.addCase(deleteManyTask.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteManyTask.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteManyTask.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default crmTaskSlice.reducer;
export const { clearTask } = crmTaskSlice.actions;
